<template>
  <div id="code" class="dark:bg-dark-code bg-gray-50 flex flex-row justify-center">
    <div class="w-full p-6">
      <h1 class="resume-section-title">{{ 'code-title' | lang('code') }}</h1>
      <div class="text-center flex flex-row flex-wrap justify-between px-10">
        <div class="p-4 cursor-pointer focus:outline-none w-1/4 hd:w-1/6 h-32 m-2 fhd:h-40 4k:h-48
          rounded-lg 4k:rounded-2xl bg-gradient-to-tr hover:from-green-400 hover:to-blue-500
          hover:text-white text-gray-900 dark:hover:from-pink-500 dark:hover:to-yellow-500
          dark:text-gray-400 dark:hover:text-gray-900 sm:text-xl fhd:text-2xl 4k:text-5xl
          flex flex-col items-center justify-center"
          @click="openLink(item.repo)"
          v-for="(item, index) in codeExampleList" :key="index">
          <IconFolder class="w-10 h-10 fhd:w-14 fhd:h-14 4k:w-20 4k:h-20" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeExampleList: [
        {
          title: 'User account',
          repo: 'https://gitlab.com/kaysoohyun-portfolio/user-example.git',
        },
        {
          title: 'Api REST',
          repo: 'https://gitlab.com/kaysoohyun-portfolio/rest-api-example.git',
        },
        // {
        //   title: 'TODO - Ecommerce',
        //   repo: '',
        // },
        // {
        //   title: 'TODO - Video player',
        //   repo: '',
        // },
        // {
        //   title: 'TODO - Maps',
        //   repo: '',
        // },
        // {
        //   title: 'TODO - User management',
        //   repo: '',
        // },
        {
          title: 'Personal Writes',
          repo: 'https://gitlab.com/KaySoohyun/shooting-star.git',
        },
        {
          title: 'Personal music player',
          repo: 'https://github.com/KaySoohyun/animeTime.git',
        }
      ]
    };
  },
  methods: {
    openLink(href) {
      if (href) {
        window.open(href, '_blank');
      }
    },
  }
};
</script>
